<template>
    <footer class="footer">
        <div class="container">
            <social customClass="footer" />
            <div class="footer__deco">
                <svg xmlns="http://www.w3.org/2000/svg" class="footer__deco-svg">
                    <use v-bind="{'xlink:href': sprite + '#dashed-line'}" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
            </div>
            <div class="footer__copy">
                <p>&copy;{{year}} todos os direitos reservados | desenvolvido por <a href="https://italofontes.com">Italo Fontes</a></p>
            </div>
        </div>
    </footer>
</template>
<script>
import Social from "@/components/Social.vue";
import { dateMixin } from "@/misc/mixins";

export default {
  components: {
    Social,
  },
  mixins: [dateMixin],
  computed: {
    sprite: function() {
      return require("@/assets/decor-sprite.svg");
    },
  },
};
</script>
<style lang="scss">
.footer {
  background-color: $color-wine;
  text-align: center;
  color: $color-cream;
  font-size: 1.4rem;
  padding: 5rem 0 3rem 0;

  &__deco-svg {
    stroke: $color-cream;
    width: 30rem;
    height: 10rem;
  }
}
</style>
